module.exports = __webpack_public_path__ + "img/Monte_Kope_114.37358eac.jpg";